import { Component, Input, OnInit } from '@angular/core';
import * as Highcharts from 'src/assets/js/highcharts';
// import DrillDown from 'src/assets/js/highchartJS/code/modules/drilldown';
// DrillDown(Highcharts)


@Component({
  selector: 'g10-highchart-barchart',
  templateUrl: './highchart-barchart.component.html',
  styleUrls: ['./highchart-barchart.component.css']
})
export class HighchartBarchartComponent implements OnInit {
  @Input('style') chartStyle:Object = { 'height' : '100%'};
  @Input('id') chartID:string = 'G10-Highchart-Barchart-'+ Math.floor(Math.random()*100000000);
  @Input() public set chartOptions(val:any){
    if(val && Object.keys(val).length>0){
      setTimeout(()=>{
        this.initiateChart(val);
      },1000);
    }
  } 
  public highchartChartEl:any;
  constructor() { }

  ngOnInit(): void {
    // this.initiateChart({});
  }

  initiateChart(options){
    // console.log(this.chartID,document.getElementById(this.chartID))
    this.highchartChartEl =  Highcharts.chart(this.chartID, options);
  }

}
